import { useIntl } from 'react-intl'
import {
    StyledBlock,
    StyledBodyContainer,
    StyledContainer,
    StyledCrownContainer,
    StyledExplanationBlockContainer,
    StyledExplanationsContainer,
    StyledIllustrationGainsContainer,
    StyledIllustrationRightContainer,
    StyledLeftContainer,
    StyledTitleWinContainer
} from './styles'
import { fonts } from '../../../../../app-v2/design-systems'
import { colors } from 'shared/assets/styles'
import React from 'react'
import { H3, H4, Text } from '../../../../common/typography'
import { useWindowDimensions } from '../../../utils'
import { breakpoints } from '../../../../assets/styles'
//$FlowFixMe
import crownMobile from '../../../assets/crown.webp'
//$FlowFixMe
import crown from '../../../assets/crown-2.webp'
//$FlowFixMe
import gainsMobile from '../../../assets/gains.webp'
//$FlowFixMe
import gains from '../../../assets/gains-2.webp'
import { ListItem } from './components/ListItem'

export const ExplanationsToBigWin = () => {
    const intl = useIntl()
    const { width: windowWidth } = useWindowDimensions()
    const isSmall = windowWidth <= breakpoints.small
    const Title = isSmall ? H3 : H4
    return (
        <StyledExplanationsContainer>
            <StyledExplanationBlockContainer>
                <StyledBlock>
                    <StyledContainer>
                        <StyledLeftContainer>
                            <StyledCrownContainer>
                                <img
                                    src={isSmall ? crownMobile : crown}
                                    alt={'crown'}
                                />
                            </StyledCrownContainer>
                            <StyledTitleWinContainer>
                                <Title
                                    color={colors.bbqBrown}
                                    font={fonts.flameBold}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanations.big.win.title'
                                    })}
                                </Title>
                            </StyledTitleWinContainer>
                            <StyledBodyContainer>
                                <ListItem
                                    number={1}
                                    text={intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanations.big.win.text.1'
                                    })}
                                />
                                <ListItem
                                    number={2}
                                    text={intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanations.big.win.text.2'
                                    })}
                                />
                                <ListItem
                                    number={3}
                                    text={intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanations.big.win.text.3'
                                    })}
                                />
                                <ListItem
                                    number={4}
                                    text={intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanations.big.win.text.4'
                                    })}
                                />
                            </StyledBodyContainer>
                            {isSmall && (
                                <StyledIllustrationGainsContainer>
                                    <img
                                        src={gainsMobile}
                                        alt={'gainsMobile'}
                                    />
                                </StyledIllustrationGainsContainer>
                            )}
                        </StyledLeftContainer>
                        {!isSmall && (
                            <StyledIllustrationRightContainer>
                                <img src={gains} alt={'gains'} />
                            </StyledIllustrationRightContainer>
                        )}
                    </StyledContainer>
                </StyledBlock>
            </StyledExplanationBlockContainer>
        </StyledExplanationsContainer>
    )
}
